<template>
  <!-- prettier-ignore -->
  <svg xmlns="http://www.w3.org/2000/svg" 
    :viewBox="'0 0 '+width+' '+height" 
    :aria-labelledby="iconName" 
    role="presentation"
    :style="iconStyle"
    :class="iconClass"
  >
    <title :id="iconName" lang="en">{{iconName}} icon</title>
    <g :fill="iconColor" :stroke="stroke">
      <slot />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  overflow: visible;
  width: 100%;
  height: auto;
}
</style>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 30,
    },
    height: {
      type: [Number, String],
      default: 30,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
    iconStyle: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    stroke: {
      type: String,
      default: '',
    },
  },
};
</script>
